import { render } from "./SearchResults.vue?vue&type=template&id=ef9fb840&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=ef9fb840&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9fb840"]])

export default __exports__